import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Module } from 'src/app/interfaces/module.interface';

@Component({
    selector: 'app-gallery-module',
    templateUrl: './gallery-module.component.html',
    styleUrls: ['./gallery-module.component.scss']
})
export class GalleryModuleComponent implements OnInit {
    @Input() module: Module;
    @Input() i: number;
    @Input() postColor;
    @Input() logo: any;
    postLoaded: boolean = false;
    bannerItem: any;
    viewPortActive: boolean = false;
    videoelement = {
        video_id: null,
        play_method: null
    }
    preloader_color;
    screenWidth: number = 0;

    constructor() {
        this.onResize();
    }

    ngOnInit() {
        this.videoelement.video_id = this.module.video_gallery;
        this.videoelement.play_method = this.module.video_option;
        this.preloader_color = this.getRandomColor();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }
    
    loadedImage() {
        this.postLoaded = true;
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.viewPortActive = true;
        }
        if (visible && !this.bannerItem) {
            this.bannerItem = this.module.photo_gallery.url
        }
    }

    getRandomColor() {
        const hue = 0;
        const saturation = 0;
        const brightness = this.getRandomNumber(85, 95);
        return 'hsl(' + hue + ', ' + saturation + '%, ' + brightness + '%)';
    }

    getRandomNumber(low, high) {
        var r = Math.floor(Math.random() * (high - low + 1)) + low;
        return r;
    }
}
